import { render, staticRenderFns } from "./ClaimPage.vue?vue&type=template&id=626f2460&"
import script from "./ClaimPage.vue?vue&type=script&lang=js&"
export * from "./ClaimPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports